import React, { useEffect } from "react";
import { Table, Typography, Button } from "antd";
import {
  LeftCircleOutlined,
  PaperClipOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { Link, useParams } from "react-router-dom";
import { ConnectedProps } from "react-redux";

import {
  NavigationPath,
  otherInsuranceResponseColumns,
  requestDetailsColumns,
} from "../../../utils";
import ResponseForm from "./ResponseForm";
import ResponsePreview from "./ResponsePreview";
import connector from "./Container";
import {
  InsuranceOfferResponseType,
  offerRequestFileType,
} from "../../../models";

const RequestDetails = ({
  actions,
  state,
}: ConnectedProps<typeof connector>) => {
  const { requestDetails, loggedUser, isSent } = state;
  const { id } = useParams();

  useEffect(() => {
    if (id && loggedUser) {
      actions.getInsuranceOfferRequestsDetails(id, loggedUser.organizationId);
    }
  }, [id, loggedUser]);

  const handleFileDownload = (file: offerRequestFileType) => {
    if (actions.downloadFile && id) {
      actions.downloadFile(id, file.id, file.originalName);
    }
  };

  const responseDataSource =
    requestDetails?.offerResponse?.map(
      (response: InsuranceOfferResponseType) => ({
        ...response,
        key: response.id,
      })
    ) || [];

  return (
    <div className="bg-white">
      <div className="px-8 py-4">
        <div className="font-bold">
          <Link
            to={NavigationPath.INSURANCE_OFFER_REQUESTS_ROUTE}
            className="text-base text-secondary"
          >
            <LeftCircleOutlined /> NAZAD NA ZAHTJEVE ZA PONUDE /
          </Link>
          <Typography className="inline text-base text-offer-blue ml-1">
            {requestDetails?.name}
          </Typography>
        </div>
      </div>
      <div className="h-5 bg-base-gray"></div>
      <div className="px-8 py-4">
        <Table
          columns={requestDetailsColumns()}
          dataSource={[{ ...requestDetails, key: id }]}
          pagination={false}
        />
        <div className="m-4 flex">
          <Typography className="mt-1">Prilozi:</Typography>
          <div className="flex flex-col gap-2 ml-2">
            {requestDetails?.files?.map((file: offerRequestFileType) => (
              <div
                key={file.id}
                className="inline-flex items-center justify-between bg-light-gray"
              >
                <div className="flex items-center">
                  <PaperClipOutlined className="text-black opacity-45 sm:ml-2" />
                  <span className="ml-2 text-primary">{file.originalName}</span>
                </div>

                <Button
                  type="text"
                  onClick={() => handleFileDownload(file)}
                  className="border-none sm:ml-32 flex items-center text-xs font-bold text-offer-blue bg-light-gray"
                >
                  PREUZMI
                  <DownloadOutlined className="text-offer-blue ml-1 text-base" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="h-5 bg-base-gray"></div>
      <div className="px-8 py-4">
        <Typography className="text-xl font-bold text-secondary text-center mb-2">
          KO JE ODGOVORIO:
        </Typography>
        <Table
          columns={otherInsuranceResponseColumns()}
          dataSource={responseDataSource}
          pagination={false}
        />
      </div>
      <div className="h-5 bg-base-gray"></div>
      {isSent ? <ResponsePreview /> : <ResponseForm />}
    </div>
  );
};

export default RequestDetails;
